import React, { useEffect, useState } from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import ModalDetailsContent from "./modal-details-content.jsx";
import { FaSearch } from "react-icons/fa";
import {readjustTimezone, translateVehicleType} from "../utils/translate.jsx";

const BASENAME = import.meta.env.BASE_URL;

const DetailsContent = ({ data, exportVehicle, exportStation }) => {
    const [limitVehicle, setLimitVehicle] = useState(10);
    const [limitGasStation, setLimitGasStation] = useState(10);

    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const vehicleData = data?.getSuppliesByVehicle ?? [];
    const gasStationData = data?.getSuppliesByGasStation ?? [];

    const passedVehicleLimit = vehicleData.length > limitVehicle;
    const passedGasStationLimit = gasStationData.length > limitGasStation;

    const seeMoreOrLessVehicle = () => {
        setLimitVehicle(prev => prev ? null : 10);
    };

    const seeMoreOrLessGasStation = () => {
        setLimitGasStation(prev => prev ? null : 10);
    };

    useEffect(() => {

        const vehicleValues = exportVehicle.map(element => ([
            element.text,
            element.conductor,
            readjustTimezone(element.date),
            element.fuel_type,
            element.qty,
            element.price,
            element.gas_station
        ]));

        ReportUtils.createExportableTable(["Prefixo - Placa", "Condutor", "Data/Hora", "Combustível", "Quantidade", "Total pago", "Posto de combustível"], vehicleValues, "Abastecimento por veículo");

        const gasStationValues = exportStation.map(element => ([
            element.text,
            element.vehicle,
            element.conductor,
            readjustTimezone(element.date),
            element.fuel_type,
            element.price
        ]));

        ReportUtils.createExportableTable(["Posto de combustível", "Veículo", "Condutor", "Data/Hora", "Combustível", "Total pago"], gasStationValues, "Abastecimento por posto");

    }, [data]);

    const detailsModal = (item) => {
        setSelectedItem({
            ...item,
            supply_details: JSON.parse(item.supply_details || "[]")
        });

        setOpen(true);
    };

    return (
        <div id="fleet-details" className="print:break-inside-auto!">

            <div className="report-divisor mb-6">
                <span className="divisor-title">
                    DETALHAMENTO
                </span>
            </div>

            <div className="chart-report print:break-inside-auto!">

                <span className="chart-title">
                    Abastecimentos por veículo {passedVehicleLimit && limitVehicle ? "(TOP 10)" : ""}
                </span>

                {
                    !vehicleData.length ? (
                        <div className="alert alert-info p-2 h6 text-center mt-3">
                            Nenhum registro encontrado no período informado.
                        </div>
                    ) : (
                        <div className="mt-3 mb-6">

                            <table id="fleet-supplies-vehicle-detail-data" className="table report-table print:break-inside-auto!" sheet-name={'Abastecimentos por veículo'}>

                                <thead className="thead-background print:table-row-group!">
                                    <tr className="bg-[#f6f6f6] text-left">
                                        <th className={"w-[12%]"}>Prefixo - Placa</th>
                                        <th className={"w-[12%]"}>Tipo</th>
                                        <th className={"w-[10%]"}>Quantidade</th>
                                        <th className={"w-[12%]"}>Média quantidade</th>
                                        <th className={"w-[16%]"}>Variação quantidades</th>
                                        <th className={"w-[10%]"}>Total pago</th>
                                        <th className={"w-[14%]"}>Média pagamentos</th>
                                        <th className={"w-[12%]"}>Variação pagamentos</th>
                                        <th className={"w-[1%] print:hidden"}></th>
                                    </tr>
                                </thead>

                                <tbody className="bg-white">
                                    {(limitVehicle ? vehicleData.slice(0, limitVehicle) : vehicleData).map((element, index) => {
                                        const supplyDetails = JSON.parse(element.supply_details || "[]");
                                        const vehicleId = supplyDetails?.[0]?.vehicle_id;

                                        return (
                                            <>

                                                <tr key={index}>
                                                    <td className={"w-[12%]"}><a href={`${BASENAME}vehicles/form/${vehicleId}`} target={"_blank"} className={'inner-link'}>{element.text}</a></td>
                                                    <td className={"w-[12%]"}>{translateVehicleType(element.type)}</td>
                                                    <td className={"w-[10%]"}>{element.fuel_qty}</td>
                                                    <td className={"w-[12%]"}>{element.avg_qty}</td>
                                                    <td className={"w-[16%]"}>{element.qty_variation}</td>
                                                    <td className={"w-[10%]"}>{element.total_pay}</td>
                                                    <td className={"w-[14%]"}>{element.avg_price}</td>
                                                    <td className={"w-[12%]"}>{element.pay_variation}</td>
                                                    <td className={"w-[1%] print:hidden"}>
                                                        <FaSearch
                                                            size={17}
                                                            title={'Detalhes do abastecimento'}
                                                            className={'details-link'}
                                                            onClick={() => detailsModal(element)}
                                                        />
                                                    </td>
                                                </tr>

                                            </>
                                        );
                                    })}
                                </tbody>

                            </table>

                            {passedVehicleLimit && (
                                <div className="text-end mt-1">
                                    <span className="see-more print-hide" onClick={seeMoreOrLessVehicle} style={{ cursor: "pointer" }}>
                                        {limitVehicle ? "Ver mais" : "Ver menos"}
                                    </span>
                                </div>
                            )}

                            <div className="obs-warn !mt-2">Variação (%): Desvio em relação à média de cada veículo. Valores elevados (ex: acima de 30%) indicam abastecimentos e valores fora do padrão comum para aquele prefixo.</div>

                        </div>
                    )
                }

            </div>

            <div className="chart-divisor"/>

            <div className="chart-report print:break-inside-auto!">
                <span className="chart-title">Abastecimentos por posto de combustível {passedGasStationLimit && limitGasStation ? "(TOP 10)" : ""}</span>

                {
                    !gasStationData.length ? (
                        <div className="alert alert-info p-2 h6 text-center mt-3">
                            Nenhum registro encontrado no período informado.
                        </div>
                    ) : (
                        <div className="mt-3 mb-6">

                            <table id="fleet-supplies-gas-station-detail-data" className="table report-table print:break-inside-auto!" sheet-name={'Abastecimentos por posto'}>

                                <thead className="thead-background print:table-row-group!">
                                    <tr className="bg-[#f6f6f6] text-left">
                                        <th className={"w-[20%]"}>Posto de combustível</th>
                                        <th className={"w-[20%]"}>Combustível</th>
                                        <th className={"w-[20%]"}>Quantidade</th>
                                        <th className={"w-[15%]"}>Valor</th>
                                        <th className={"w-[23%]"}>Valor médio por unidade</th>
                                        <th className={"w-[2%] print:hidden"}></th>
                                    </tr>
                                </thead>

                                <tbody className="bg-white">
                                    {(limitGasStation ? gasStationData.slice(0, limitGasStation) : gasStationData).map((element, index) => (
                                        <tr key={index}>
                                            <td className={"w-[20%]"}>{element.text}</td>
                                            <td className={"w-[20%]"}>{element.type}</td>
                                            <td className={"w-[20%]"}>{element.fuel_qty}</td>
                                            <td className={"w-[15%]"}>{element.prefix}</td>
                                            <td className={"w-[23%]"}>{element.avg_price}</td>

                                            <td className={'w-[2%] print:hidden'}>
                                                <FaSearch
                                                    size={17}
                                                    title={`Abrir detalhes de ${element.text}`}
                                                    className={'details-link'}
                                                    onClick={() => detailsModal(element)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>

                            {passedGasStationLimit && (
                                <div className="text-end mt-1">
                                    <span className="see-more print-hide" onClick={seeMoreOrLessGasStation} style={{ cursor: "pointer" }}>
                                        {limitGasStation ? "Ver mais" : "Ver menos"}
                                    </span>
                                </div>
                            )}

                        </div>
                    )
                }

            </div>

            {open && selectedItem && (
                <ModalDetailsContent
                    open={open}
                    setOpen={setOpen}
                    data={selectedItem}
                />
            )}

        </div>
    );
};

export default DetailsContent;
